import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { Button, Spinner } from "react-bootstrap";
import { initialUserUrls } from "../databases/spName";
import { UpdateUser } from "../databases/users";
import { GetOwnURLS } from "../databases/files";
import { ICON_PROFILE_CANCEL, ICON_PROFILE_EDIT, ICON_PROFILE_OK } from "../components/icons";
import RenderUpdateProfile from "../components/RenderUpdateProfile";

const PageProfile = () => {

    const { owndata, setOwndata } = useContext(AuthContext)

    const [onEdit, setOnEdit] = useState(false);
    const [mEdit, setMEdit] = useState({});
    const [urls, setUrls] = useState({...initialUserUrls})
    const [onLoading, setOnLoading] = useState(false)

    useEffect(() => {
        const q = async () => {
            const u = await GetOwnURLS()
            setUrls(i => ({...i, ...u} ))
        }
        q();
        return () => {
            setOnEdit(false)
            setMEdit({})
            setUrls({...initialUserUrls})
            setOnLoading(false)
        }
    }, [])

    useEffect(() => {
        setMEdit({...owndata})
    }, [owndata])

    const onEditClick = async () => {
        alert('โปรดอย่าลืมกด "บันทึก"')
        setOnEdit(true)
        setMEdit({...owndata})
    }

    const onSaveClick = async () => {
        setOnLoading(true)
        await UpdateUser({...mEdit})
            .then(() => {
                setOwndata({...mEdit})
                alert('อัปเดตสำเร็จ')
                setOnEdit(false)
            })
            .catch(() => alert('เกิดข้อผิดพลาด'))
            .finally(() => {
                setOnLoading(false)
            })
    }

    const onCancelClick = () => {
        setOnEdit(false)
        setMEdit({...owndata})
    }

    return (
        <div>
            <div className="text-end">
                <Button variant="warning" hidden={onEdit} onClick={onEditClick}>{ICON_PROFILE_EDIT} แก้ไขข้อมูล</Button>
                <Button variant="danger" hidden={!onEdit} onClick={onCancelClick}>{ICON_PROFILE_CANCEL }ยกเลิก</Button>
                <Button variant="success" hidden={!onEdit} disabled={onLoading} onClick={onSaveClick}>{onLoading ? <Spinner animation="border" size='sm' /> : ICON_PROFILE_OK }  บันทึก</Button>
            </div>
            <RenderUpdateProfile onEdit={onEdit} data={mEdit} setData={setMEdit} urls={urls} setUrls={setUrls}/>
            <br />
            {/*<Button variant="round-success" onClick={() => {}}>{ICON_HEADER_FLIGHT}</Button> ลงทะเบียนเที่ยวบินเหมาลำ กับทีมงาน#พาเด็กไทยกลับจีน*/}
            <br /><br />
        </div>
        
    )
}

export default PageProfile;